// extracted by css-extract-rspack-plugin
export default {"results":"results-_XnxkL"};